import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getAllTableBookings } from "../../../api/user/restaurants";
import moment from "moment";

const Reservations = ({ restaurantId }) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["reservations", restaurantId],
    queryFn: () => getAllTableBookings({ page: 1, limit: 10, restaurantId }),
    enabled: !!restaurantId,
  });

  const reservations = data?.data?.reservations;
  const pagination = data?.data?.pagination;

  if (isLoading) return <p>Loading reservations...</p>;
  if (error) return <p>Error fetching reservations</p>;
  if (!reservations?.length)
    return <p className="text-center ">No reservations found.</p>;

  return (
    <div className="flex flex-col space-y-4 p-4">
      {reservations.map((reservation) => {
        const status = reservation?.status?.toLowerCase();
        const bookingDate = moment(reservation.bookingDate).format(
          "YYYY-MM-DD"
        );
        const endTime = reservation?.slot?.endTime;
        let isExpired = false;

        if (bookingDate && endTime) {
          const [endHour, endMinute] = endTime.split(":");
          const endDateTime = moment(bookingDate).set({
            hour: +endHour,
            minute: +endMinute,
            second: 0,
            millisecond: 0,
          });
          isExpired = moment().isAfter(endDateTime);
        }

        return (
          <div
            key={reservation._id}
            className="bg-white rounded-2xl shadow-md p-5 border border-gray-200"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-lg font-semibold text-gray-800">
                Reservation #{reservation.reservationId}
              </h3>
              <div>
                {(() => {
                  if (
                    (status === "pending" ||
                      status === "awaiting payment" ||
                      status === "confirmed") &&
                    isExpired
                  ) {
                    return (
                      <span className="bg-gray-500 text-white px-3 py-1 rounded-full text-xs">
                        Expired
                      </span>
                    );
                  }
                  if (status === "pending") {
                    return (
                      <span className="bg-yellow-500 text-white px-3 py-1 rounded-full text-xs">
                        Pending
                      </span>
                    );
                  }
                  if (status === "awaiting payment") {
                    return (
                      <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs">
                        Awaiting Payment
                      </span>
                    );
                  }
                  if (status === "confirmed") {
                    return (
                      <span className="bg-green-600 text-white px-3 py-1 rounded-full text-xs">
                        Confirmed
                      </span>
                    );
                  }
                  if (status === "cancelled") {
                    return (
                      <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs">
                        Cancelled
                      </span>
                    );
                  }
                  return (
                    <span className="bg-gray-300 text-black px-3 py-1 rounded-full text-xs">
                      {reservation?.status}
                    </span>
                  );
                })()}
              </div>
            </div>

            {/* Body */}
            <div className="grid grid-cols-2 gap-y-2 text-sm text-gray-700">
              <p>
                <span className="font-medium">Date:</span>{" "}
                {moment(reservation.bookingDate).format("DD MMM YYYY")}
              </p>
              <p>
                <span className="font-medium">Time:</span>{" "}
                {reservation?.slot?.startTime} - {reservation?.slot?.endTime}
              </p>

              <p>
                <span className="font-medium">Meal:</span>{" "}
                {reservation.mealType}
              </p>
              <p>
                <span className="font-medium">Guests:</span>{" "}
                {reservation.totalGuest}
              </p>

              <p>
                <span className="font-medium">Food:</span>{" "}
                {reservation.foodType}
              </p>
              <p>
                <span className="font-medium">Token:</span> ₾
                {reservation.tokenCharges}
              </p>

              <p>
                <span className="font-medium">Discount:</span>{" "}
                {reservation.discountPercentage}%
              </p>
              <p>
                <span className="font-medium">Table:</span>{" "}
                {reservation.tableNo || "-"}
              </p>

              <p>
                <span className="font-medium">Code:</span>{" "}
                {reservation.tableCode || "-"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Reservations;
